<template>
  <div>
    <nav class="nav-ban" v-if="!isApp">
      <img @click="handleClick" class="nav-icon" src="../assets/images/mobile/leftarrow.svg" alt="">
      <h3 class="nav-title">{{ title }}</h3>
    </nav>
    <div style="width:100%;height:30px;" v-if="!isApp"></div>
  </div>
</template>

<script>
export default {
  name: 'navBan',
  props: {
    title: {
      type: String,
      default: () => '标题'
    },
    goBack: { type: Function }
  },
  data () {
    return {
      isApp: false
    };
  },
  created () {
    const PlatForm = sessionStorage.getItem('PlatFormType');
    if (PlatForm == 1 || PlatForm == 2) {
      this.isApp = true;
    }
    // let agent = navigator.userAgent.toLowerCase();
    // if (agent.indexOf('android') >= 0 || agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    //   this.isApp = true;
    // }
  },
  methods: {
    handleClick () {
      typeof this.goBack === 'function' ? this.goBack() : this.handleBack();
    },
    handleBack () {
      const PlatForm = sessionStorage.getItem('PlatFormType');
      let routername = this.$router.currentRoute.value.name;
      if (routername == 'rebindPhone' || routername == 'modifyPwd') {
        this.$router.replace({
          name: 'accountSet',
          query: {PlatFormType: PlatForm || '0'}
        });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-ban {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  background-color: #fff;
  .nav-title {
    margin: 0 auto;
    width: 248px;
    text-align: center;
    color: rgba(0, 19, 46, 1);
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
  }
}
</style>
